export default "__VITE_ASSET__BFtsGwwj__"